import React from 'react';

const CategorySeparator = ({
  separationLinesList,
  columns,
  calculateColumnWidths,
  subdivisionWidths,
  useCustomWidths,
  firstColumnWidth,
  splitMode,
  subdivisionRefs,
  handleFocus
}) => {
  const fallback = ['OUTROS', 'ESPECIALISTAS', 'FAO'];
  const [category, specialistsLabel, faoLabel] = Array.isArray(separationLinesList) &&
  separationLinesList.length === 3 && separationLinesList.every(item => typeof item === 'string')
    ? separationLinesList
    : fallback;


  return (
    <div className="flex">
      <div
        className="bg-white border-t border-r-2 border-gray-300 h-[40px] flex items-center font-bold text-sm px-2 gap-2 sm:text-md static md:sticky left-0 z-10 sm:text-md"
        style={{ width: useCustomWidths ? calculateColumnWidths[0] + 'px' : firstColumnWidth + 'px', }}
      >
        <input
          type="text"
          value={category}
          readOnly
          className="bg-transparent border-none outline-none w-full font-bold text-sm"
          title={category}
          style={{ width: useCustomWidths ? calculateColumnWidths[0] + 'px' : firstColumnWidth + 'px', }}
        />
      </div>

      {columns.slice(1).map((_, index) => {
        const colIndex = index + 1;
        
        return (
          <div
            key={colIndex}
            className="flex items-center font-bold sm:text-sm text-xs border-t border-gray-300"
            style={{ width: colIndex !== 1 ? calculateColumnWidths[colIndex] + 'px' : (calculateColumnWidths[colIndex] - 2) + 'px', height: '40px' }}
          >
            <div className="flex flex-row w-full h-full relative border">
              {splitMode ? (
                <>
                  <div 
                    ref={(el) => {
                      if (el) {
                        subdivisionRefs.current[`${colIndex}-specialists`] = el;

                      }
                    }}
                    className="flex items-center bg-gray-50 border-l px-2 focus:outline-none font-bold text-sm overflow-x-auto whitespace-nowrap text-ellipsis no-scrollbar"
                    style={{ width: colIndex !== 1 ? (subdivisionWidths[colIndex].city + 4) : (subdivisionWidths[colIndex].city + 2) }}
                  >
                    {specialistsLabel}
                  </div>
                  <div 
                    ref={(el) => {
                      if (el) {
                        subdivisionRefs.current[`${colIndex}-fao`] = el;
                      }
                    }}
                    className="flex items-center pl-2 bg-gray-50 border-l focus:outline-none font-bold text-sm text-gray-600 w-1/2 overflow-x-auto whitespace-nowrap text-ellipsis no-scrollbar"
                    style={{ width: subdivisionWidths[colIndex].fao }}
                  >
                    {faoLabel}
                  </div>
                  {(faoLabel === "" || faoLabel === "FAO") && (
                    <span className="absolute right-1 pt-1.5 font-bold text-gray-600">%</span>
                  )}
                </>
              ) : (
                <input
                  type="text"
                  value={specialistsLabel}
                  readOnly
                  className="bg-transparent border-none focus:outline-none w-full font-bold text-sm"
                  title={specialistsLabel}
                  onFocus={(e) => handleFocus(e.target)}
                />
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default React.memo(CategorySeparator);
